<template>
  <div class="page-container">
    <div class="forgot-password-container">
      <div class="header">Set new password</div>

      <v-form class="signup-form" v-model="isFormValid">
        <v-text-field class="password my-3" autocomplete="new-password" v-model="password" :type="showPassword ? 'text' : 'password'" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassword = !showPassword" ref="password" label="Password" :rules="notEmptyRules" hide-details="auto"></v-text-field>
        <v-text-field class="confirm-password my-3" autocomplete="new-password" v-model="passwordConfirm" :type="showPassword ? 'text' : 'password'" :rules="confirmPasswordRules.concat(passwordConfirmationRule)" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassword = !showPassword" ref="password" label="Confirm Password" hide-details="auto"></v-text-field>
        <v-btn type="submit" :disabled="!isFormValid || loading" :loading="loading" @click="submit" class="set-new-button" color="#5774E7" width="300px" height="38px">Reset password</v-btn>
      </v-form>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Login",
  data: () => ({
    loading: false,
    isFormValid: false,
    showPassword: false,
    showConfirmPassword: false,
    password: "",
    passwordConfirm: "",
    notEmptyRules: [(value) => !!value || "Required."],
    confirmPasswordRules: [(v) => !!v || "Password is required"],
  }),
  computed: {
    passwordConfirmationRule() {
      return () => this.password === this.passwordConfirm || "Password must match";
    },
  },
  methods: {
    submit() {
      this.loading = true;

      axios
        .post(this.$store.state.serverURL + "/users/resetpassword", { token: this.$route.query.token, password: this.password }, { withCredentials: true })
        .then((res) => {
          this.loading = false;

          this.$toast.success("Successfully changed password", { position: "bottom-right", timeout: 7500 });
          this.$router.push("/login");
        })
        .catch((err) => {
          this.loading = false;
          this.$toast.error(err.request.responseText, { position: "bottom-right", timeout: 7500 });
        });
    },
  },
};
</script>

<style scoped>
.forgot-password-container {
  width: 380px;
  height: 350px;
  position: absolute;
  top: calc(50% - 225px);
  left: calc(50% - 190px);
  background-color: white;
  box-shadow: 0px 2px 4px rgba(0, 41, 199, 0.2);
  border-radius: 4px;
  display: flex;
  justify-content: center;
}
.password {
  width: 300px;
  position: absolute;
}
.confirm-password {
  width: 300px;
  position: absolute;
  top: 70px;
}

.signup-form {
  position: absolute;
  top: 120px;
  width: 300px;
}
.header {
  width: 100%;
  height: 100px;
  background-color: #5774e7;

  color: white;

  position: absolute;
  padding-top: 35px;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  /* identical to box height, or 133% */

  text-align: center;
}

.set-new-button {
  position: absolute;
  top: 160px;
  color: white;
}
</style>
